import { Table,Form } from "react-bootstrap";
import cflService from "../service/cfl-service";

const Tabla_Cursos = ({ curso,setFilaCurso,setVisible,setAlumnosxCruso,setLoadingAlumnosMatriculados }) => {
    const handleCheck =(data)=>{
        //console.log(data)
        setLoadingAlumnosMatriculados(true)
        cflService.buscarAlumnosMatriculadosCurso(data.idCurso)
        .then((resp)=>{
            //console.log(resp.data.data)
            setAlumnosxCruso(resp.data.data)
            setLoadingAlumnosMatriculados(false)
        })
        setFilaCurso(data)
        setVisible(true)
    }

    return (
        <Table striped  hover className="mt-3" responsive >
            <thead>
                <tr>
                    <th className="text-center bg-dark text-white">N° de Curso</th>
                    <th className="bg-dark text-white">Nombre</th>
                    <th className="text-center bg-dark text-white">Inicio</th>
                    <th className="text-center bg-dark text-white">Finalización</th>
                    <th className="text-center bg-dark text-white">Acción</th>
                </tr>
            </thead>
            <tbody>

                {curso.map((data, i) => {
                    return (
                        <tr key={i}>
                            <td className="text-center">{data.nroCurso}</td>
                            <td>{data.nombre}</td>
                            <td className="text-center">{data.fechaInicio}</td>
                            <td className="text-center">{data.fechaFinalizacion}</td>
                            <td className="text-center">
                                <div className="center-accion">
                                <Form.Check
                                    onClick={()=>handleCheck(data)}
                                    name="group2"
                                    type="radio"
                                   
                                 />
                                 </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </Table>
    )
}

export default Tabla_Cursos;